import React from "react";
import "./spinner.scss";

export const Spinner = () => {
    return (
            <span className="loader" />
    );
};
